<template>
  <IframeWrap :option="wrapSize" @loaded="handleLoad">
    <template v-slot:banner-btn>
      <div class="flex items-center space-x-3 text-white">
        <span v-show="!isLoading" class="cursor-pointer" @click="refresh">刷新</span>
        <span v-show="!isLoading" class="cursor-pointer" @click="reset">重置</span>
      </div>
    </template>
    <div v-if="isLoading" class="flex flex-col items-center justify-center h-full w-full">
      <img v-if="!loadError" class="loading" src="./loading-icon.svg" alt="" />
      <span class="text-center text-white">{{ loadError ? loadError.message : '加载中' }}</span>
    </div>
    <iframe
      v-else
      allowfullscreen="true"
      allow="camera;microphone;display-capture"
      width="100%"
      frameborder="0"
      :src="iframeUrl"
    ></iframe>
  </IframeWrap>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import initSpecial, {
  initJupyter,
  terminateJupyter
} from '@/components/resources/dialog/PracticeCourt/initSpecial';
import { IJupyterConfig } from '@/components/resources/dialog/JupyterIframe/types';
import { Environment } from '@/store/modules/common/types';
import IframeWrap from '@/components/iframe-wrap';
import { IIframewrap } from '@/components/iframe-wrap/type';

const commonMadel = namespace('common');

@Component({
  components: {
    IframeWrap
  }
})
export default class JupyterIframe extends Vue {
  @Prop({ type: Object }) content!: Content & IJupyterConfig & IIframewrap;
  @commonMadel.State('clewordNavVisible') clewordNavVisible: boolean;
  @commonMadel.State('setyleNavHeight') setyleNavHeight: number;
  @commonMadel.State('environment') environment!: Environment;

  isEnlarge = false;
  isLoading = true;
  loadError: Error | null = null;
  iframeUrl = '';
  practiceId = '';

  get wrapSize() {
    return {
      width: this.content.width,
      height: this.content.height
    };
  }

  mounted() {
    this.refresh();
  }

  refresh() {
    this.isLoading = true;
    const courseId =
      this.environment &&
      this.environment.kind === 'public-preview' &&
      this.environment.sharedKey.length === 24
        ? this.environment.sharedKey
        : '';

    initJupyter
      .call(
        this,
        {
          sourceUser: this.content.sourceUser,
          mainFile: this.content.mainFile,
          otherFiles: this.content.otherFiles
        },
        courseId
      )
      .then((res) => {
        if (res?.url) {
          this.iframeUrl = res.url;
          this.practiceId = res.practiceId;
          this.isLoading = false;
        } else {
          throw new Error('加载失败');
        }
      })
      .catch((err) => {
        this.loadError = err;
      });
  }

  async reset() {
    this.$Modal.confirm({
      type: 'warn',
      title: '确定重置？',
      descript: '重置会清空当前操作历史，回到原始状态',
      onOk: async () => {
        this.isLoading = true;
        await terminateJupyter.call(this, this.practiceId);
        this.refresh();
      }
    });
  }

  handleLoad() {
    this.$emit('loaded');
  }
}
</script>

<style scoped>
.wrapper {
  @apply w-full md:w-160 md:ml-12 md:mr-12 rounded-motif overflow-hidden shadow-lg;
  /* background-image: linear-gradient(to right, #6f41ef, #9f7ff7); */
  background-color: #6b6981;
  transition: 0.3s;
}

.enlarge {
  @apply fixed left-0 w-screen h-screen z-50;
  background-color: #6b6981;
  transition: 0.3s;
}

.loading {
  position: relative;
  width: 150px;
  height: 150px;
  -webkit-animation: bounce 3s linear infinite alternate;
  animation: bounce 3s linear infinite alternate;
}

.iframe {
  @apply w-full h-80 overflow-hidden bg-white;
}

.iframe > iframe {
  @apply w-full h-full;
  /* 解决固宽后有黑边问题 */
  transform: scaleX(1.004) translateX(0.1%);
}

.setting {
  @apply flex items-center justify-center cursor-pointer;
  flex: 0 0 2rem;
}
</style>
